import { observer } from "mobx-react";
import React, { Component } from "react";
import projectStore from "../../stores/projectStore";
import { Link, useLocation, useParams } from "react-router-dom";
import { LuPencil, LuTrash } from "react-icons/lu";
import { PiWarningCircleFill } from "react-icons/pi";
import Button from "../../components/Button";
import { AddNewTalentColoredIcon } from "../../assets/icons";

function withRouter(Component) {
  return function WrapperComponent(props) {
    const params = useParams();
    const location = useLocation();
    return <Component {...props} location={location} params={params} />;
  };
}
const Clients = observer(
  class Clients extends Component {
    constructor(props) {
      super(props);
      this.state = {
        showDeleteModal: false,
        deleteClient: null,
        showEditModal: false,
        editClient: null,
      };
    }

    componentDidMount() {
      projectStore.getClients(this.props.params.year);
    }

    toggleDeleteModal = (deleteClient = null) => {
      this.setState({
        showDeleteModal: !this.state.showDeleteModal,
        deleteClient: deleteClient,
      });
    };

    handleDelete = () => {
      const { deleteClient } = this.state;
      if (deleteClient) {
        console.log("deleting client", deleteClient);
        projectStore.deleteClient(deleteClient);
        this.setState({ showDeleteModal: false });
      }
    };

    toggleEditModal = (editClient = null) => {
      this.setState({
        showEditModal: !this.state.showEditModal,
        editClient: editClient,
      });
    };

    handleSave = () => {
      const { editClient } = this.state;
      if (editClient) {
        this.setState({ showEditModal: false });
      }
    };

    render() {
      const { year } = this.props.params;
      const { showEditModal, showDeleteModal, editClient } = this.state;

      return (
        <div className="flex flex-col p-8 bg-white flex-1 h-screen">
          <div className="flex flex-row justify-between mb-8 items-center">
            <div>
              <Link to={`/projects`}>Projects</Link>
              <span>{" > "}</span>
              <span className="font-bold">{year}</span>
            </div>

            {/* Add Button */}
            <div className="flex justify-end mx-6 gap-3 lg:gap-6">
              {/* Desktop Button */}
              <Button
                className="hidden md:flex rounded-md"
                onClick={() => {
                  projectStore.setCreateNewProjectModalVisible(true, {
                    year: this.props.params.year,
                  });
                }}
                icon={AddNewTalentColoredIcon}
                title={"Add New"}
              />
              {/* Mobile Button */}
              <Button
                onClick={() => {
                  projectStore.setCreateNewProjectModalVisible(true, {
                    year: this.props.params.year,
                  });
                }}
                className="flex md:hidden rounded-md"
                icon={AddNewTalentColoredIcon}
              />
            </div>
          </div>

          {/* Main Content */}
          <div className="flex justify-center lg:justify-start flex-row flex-wrap gap-6 lg:gap-12">
            {projectStore.clients &&
              projectStore.clients.map((clientName, index) => {
                return (
                  <div
                    key={clientName + index}
                    className="flex relative overflow-hidden border-[3px]  border-[#F89A1F] rounded-xl text-[#130D0D] group hover:bg-[#f89a1f] hover:border-[#F89A1F] transition-all duration-100	"
                  >
                    <Link
                      to={`/projects/${year}/${clientName}`}
                      className="flex relative overflow-hidden px-10 py-6 lg:px-16 lg:py-8"
                    >
                      <span
                        key={index}
                        className="font-medium text-xl text-[#130D0D] group-hover:text-white"
                      >
                        {clientName}
                      </span>
                    </Link>

                    <button
                      onClick={() =>
                        this.toggleDeleteModal({ clientName, year })
                      }
                      className="cursor-pointer absolute top-0 right-0 lg:top-0 lg:right-0 p-2 bg-[#f89a1f] rounded-bl-xl text-white group-hover:text-[#f89a1f] group-hover:bg-white"
                    >
                      <LuTrash />
                    </button>
                    <button
                      onClick={() => this.toggleEditModal(clientName)}
                      className="cursor-pointer absolute bottom-0 lg:bottom-auto lg:top-0 right-0 lg:right-9 p-2 bg-[#f89a1f] rounded-tl-xl lg:rounded-tl-none lg:rounded-b-xl text-white group-hover:text-[#f89a1f] group-hover:bg-white"
                    >
                      <LuPencil />
                    </button>
                  </div>
                );
              })}
          </div>

          {showDeleteModal && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
              <div className="bg-white rounded-lg p-5 w-[22rem]">
                <div className="flex flex-row justify-start items-center gap-x-2 mb-4">
                  <PiWarningCircleFill color="#F89A1F" />
                  <span className="font-normal text-sm">
                    Are you sure you want to delete this client?
                  </span>
                </div>
                <div className="flex justify-end gap-4">
                  <button
                    onClick={this.toggleDeleteModal}
                    className="border border-[#D9D9D9] bg-white rounded-sm"
                  >
                    <span className="font-normal text-sm px-3">No</span>
                  </button>
                  <button
                    onClick={this.handleDelete}
                    className="border border-black bg-black rounded-sm"
                  >
                    <span className="font-normal text-sm px-3 text-white">
                      Yes
                    </span>
                  </button>
                </div>
              </div>
            </div>
          )}

          {showEditModal && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
              <div className="bg-white rounded-lg p-5 w-[22rem]">
                <h3 className="text-lg font-semibold mb-4">Update Client</h3>

                <div className="mb-4">
                  <input
                    type="text"
                    value={editClient}
                    onChange={(e) => {
                      this.setState({ editClient: e.target.value });
                    }}
                    className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md"
                  />
                </div>

                <div className="flex justify-end gap-4">
                  <button
                    onClick={this.toggleEditModal}
                    className="border border-gray-300 bg-white px-3 py-2 rounded-xl"
                  >
                    Cancel
                  </button>
                  <Button onClick={this.handleSave} title="Update"></Button>
                </div>
              </div>
            </div>
          )}
        </div>
      );
    }
  }
);

export default withRouter(Clients);
